import {deserialize, inheritSerialization, serialize} from "cerialize";
import BaseEntity from "./BaseEntity";

@inheritSerialization(BaseEntity)
export default class ValidasiPendaftar extends BaseEntity {

    @serialize
    @deserialize
    public nomor: string = "";

    @serialize
    @deserialize
    public nama_lengkap: string = "";

    @serialize
    @deserialize
    public jenis_kelamin: string = "";

    @serialize
    @deserialize
    public nik: string = "";

    @serialize
    @deserialize
    public tempat_tgl_lahir: string = "";

    @serialize
    @deserialize
    public wilayah: string = "";

    @serialize
    @deserialize
    public komplek: string = "";

    @serialize
    @deserialize
    public kamar: string = "";

    @serialize
    @deserialize
    public sekolah: string = "";

    @serialize
    @deserialize
    public tingkat: string = "";

    @serialize
    @deserialize
    public kelas: string = "";

    @serialize
    @deserialize
    public orang_tua: string = "";

    @serialize
    @deserialize
    public nomor_telepon: string = "";

    @serialize
    @deserialize
    public alamat_lengkap: string = "";

    @serialize
    @deserialize
    public pengajian: string = "";

    @serialize
    @deserialize
    public image: string = "";

    @serialize
    @deserialize
    public status_pembayaran: string = "";

    @serialize
    @deserialize
    public status_formulir: string = "";

    @serialize
    @deserialize
    public status_persyaratan: string = "";

    public hasValid() {
        return this.kamarFeedback().valid
            && this.komplekFeedback().valid
            && this.asramaFeedback().valid
            && this.pengajianFeedback().valid
            && this.wilayahFeedback().valid;
    }

    public nikFeedback() {
        return this.defaultPropertyFeedback('nik');
    }

    public wilayahFeedback() {
        return this.defaultPropertyFeedback('wilayah');
    }

    public namaLengkapFeedback() {
        return this.defaultPropertyFeedback('nama_lengkap');
    }

    public tempatTanggalLahirFeedback() {
        return this.defaultPropertyFeedback('tempat_tgl_lahir');
    }

    public orangTuaFeedback() {
        return this.defaultPropertyFeedback('orang_tua');
    }

    public teleponFeedback() {
        return this.defaultPropertyFeedback('nomor_telepon');
    }

    public alamatFeedback() {
        return this.defaultPropertyFeedback('alamat_lengkap');
    }

    public komplekFeedback() {
        return this.defaultPropertyFeedback('komplek');
    }

    public kamarFeedback() {
        return this.defaultPropertyFeedback('kamar');
    }

    public tingkatFeedback() {
        return this.defaultPropertyFeedback('tingkat');
    }

    public kelasFeedback() {
        return this.defaultPropertyFeedback('kelas');
    }

    public asramaFeedback() {
        return this.defaultPropertyFeedback('komplek');
    }

    public pengajianFeedback() {
        return this.defaultPropertyFeedback('pengajian');
    }

    public nomorIndukFeedback() {
        return this.defaultPropertyFeedback('nomor_induk');
    }

}
